import { Component, Input } from '@angular/core';
import { CardLocations } from '../../shared/components-generals/card-product/card-product';
import { LoadGeneralComponent } from '../../shared/components-generals/load-general/load-general.component';
import { CartCard } from '../../shared/components-generals/cart-card/cart-card';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { CommonModule, NgClass } from '@angular/common';
import { Product } from '../../shared/models/products-model/products.model';
import { GeneralService } from '../../shared/services/general.service';
import { TicketService } from '../../shared/services/ticket.service';
import { WorkFlow } from '../../shared/models/ticket-model/catalogs-model';
import { LocationDetailResponse } from '../../shared/models/location-model/location.model';
import { InputGeneralCalendarComponent } from '../../shared/inputs/input-general-calendar/input-general-calendar.component';
import { ProductsService } from '../../shared/services/products.service';

@Component({
  selector: 'app-cart-products',
  imports: [
    CardLocations,
    LoadGeneralComponent,
    CartCard,
    NgClass,
    CommonModule,
    InputGeneralCalendarComponent,
  ],
  templateUrl: './cart-products.html',
  styleUrl: './cart-products.css',
})
export class CartProducts {
  private breakpointSubscription!: Subscription;
  public isLoading = false;
  public mobile = false;
  public workFlow: WorkFlow | null = null;
  @Input() locationDetail: LocationDetailResponse | null = null;

  @Input() productInCar: { [key: string]: Product } = {};

  constructor(
    private breakpointObserver: BreakpointObserver,
    private productsService: ProductsService,
    private generalService: GeneralService,
    private ticketService: TicketService,
  ) {}

  ngOnInit(): void {
    this.checkScreenSize();
    this.getWorkFlow();
  }

  ngOnDestroy() {
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }

  private checkScreenSize(): void {
    this.breakpointSubscription = this.breakpointObserver
      .observe(['(max-width: 1024px)'])
      .subscribe((result) => {
        this.mobile = result.matches;
      });
  }

  public getproductInCarList(): Product[] {
    return Object.values(this.productInCar);
  }

  public getTotal(): number {
    return Object.values(this.productInCar).reduce(
      (total, product) => total + product.Cost * (product.amount || 1),
      0,
    );
  }
  public addParamToUrl(route: string[], queryParams: { [key: string]: string | number }) {
    this.generalService.addParamToUrl(route, queryParams);
  }

  public getWorkFlow(): void {
    this.ticketService.getWorkFlow().subscribe((response) => {
      const pedidoCliente = response?.Data?.find((wf) => wf.Description === 'Pedido Cliente');
      if (pedidoCliente) {
        this.workFlow = pedidoCliente;
      }
    });
  }

  public goToCheckout(): void {
    this.isLoading = true;
    const supplies = this.getproductInCarList().map((product) => ({
      Id: product.Id,
      Quantity: product.amount || 1,
    }));

    const body = {
      CustomerId: 1,
      WorkFlowId: this.workFlow?.Id || '',
      LocationId: this.locationDetail ? this.locationDetail.Id : '',
      Supplies: supplies,
      Latitude: this.locationDetail?.Latitude || 0,
      Longitude: this.locationDetail?.Longitude || 0,
      StreetName: this.locationDetail?.StreetName || '',
    };

    this.ticketService.ticketCreate(body).subscribe((ress: any) => {
      if (ress?.Result === 'CC00FF') {
        this.productsService.deleteProducts.emit();
        this.generalService.addParamToUrl(['home'], { statusSelected: 2 });
      } else {
        this.isLoading = false;
        this.generalService.viewSnacAlert(
          ress?.Data[0].Messages[0] || 'Agrega Productos al carrito',
          'error',
          'Error',
        );
      }
    });
  }
}
